<template>
  <div>
    <el-row :gutter="0">
      <el-col :span="24">
        <el-row :gutter="0" v-show="false">
          <el-col :span="10">
            <el-form-item label="加赏任务佣金：每单加赏" label-width="50%">
              <el-input type="number" v-model="childdata.commissionPrice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <div style="width: 100%;text-align: left;font-size: 0.8rem;margin-top: -1%;line-height: 44px">
              <span>金</span>
              <span style="color: red; margin-left: 1%">
            <i class="el-icon-question"></i>
            <span>提示：如果商品不好找，强烈建议添加价格区间、商品所在地方便用户找到你的商品。</span>
            </span>
            </div>
          </el-col>
        </el-row>
        <div v-show="isShowRow('旺旺本品打标')">
          <el-divider></el-divider>
          <el-row :gutter="5" align="center" style="margin: 10px 0px;" >
            <el-col :span="24">
              <el-row>
                <el-col :span="6" style="line-height: 28px;">
                  <el-checkbox v-model="childdata.wangTagChecked">旺旺本品打标(+{{getAttrPrice('旺旺本品打标')}}金/单)</el-checkbox>
                </el-col>
                <el-col :span="18">
                  <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span>按关键字打标，打标后商品权重更高，买手更快找到商品。【按次数收费】 【打标功能说明】</span>
                </span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="2" v-if="childdata.wangTagChecked"
                      style="border: 1px solid red;margin: 5px 0px;">
                <el-col :span="24" class="bItem">
                  <el-form-item label-width="0">
                    <el-radio-group v-model="childdata.wangTagSelected">
                      <el-radio :label="0">首次接单买手打标</el-radio>
                      <el-radio :label="1">每次接单买手打标</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <div v-show="isShowRow('商家自主审核')">
        <el-divider></el-divider>
        <el-row>
          <el-col :span="6" style="line-height: 28px;">
            <el-checkbox v-model="childdata.breviewChecked">商家自主审核买号(+{{getAttrPrice('商家自主审核')}}金/单)</el-checkbox>
          </el-col>
          <el-col :span="18">
            <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span>商家自主审核买号，请在待审核买号里面及时审核，超过10分钟，系统将自动审核通过 </span>
                </span>
            </div>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('核验码')">
          <el-divider></el-divider>
          <el-row>
            <el-col :span="6" style="line-height: 28px;">
              <el-checkbox v-model="childdata.verifyCodeChecked">核验码(+{{getAttrPrice('核验码')}}金/单)</el-checkbox>
            </el-col>
            <el-col :span="18">
              <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span>仅限婚纱类目等线下店铺特殊商家使用，其他类目商家不需要勾选这个功能，否则会影响任务进行。</span>
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div v-show="isShowRow('自动验号')">
        <el-divider></el-divider>
        <el-row :gutter="5" align="center" style="margin: 10px 0px;">
          <el-col :span="24">
            <el-row>
              <el-col :span="6" style="line-height: 28px;">
                <el-checkbox v-model="childdata.autoVerifyNumChecked">自动验号(+{{getAttrPrice('自动验号')}}金/单)</el-checkbox>
              </el-col>
              <el-col :span="18">
                <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span>买手接单时，自动使用照妖镜验号过滤降权号，与【自动验号】互补使用。【按次数收费】</span>
                </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="2" v-if="childdata.autoVerifyNumChecked"
                    style="border: 1px solid red;margin: 5px 0px;">
              <el-col :span="24" class="bItem">
                <el-form-item label-width="0">
                  <el-radio-group v-model="childdata.customeVerifyReview">
                    <el-radio :label="0">首次接单买手验号</el-radio>
                    <el-radio :label="1">每次接单买手验号</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('核对商品链接')">
        <el-divider></el-divider>
        <el-row>
          <el-col :span="6" style="line-height: 28px;">
            <el-checkbox v-model="childdata.verifyGoodLinkChecked">核对商品链接(+{{getAttrPrice('核对商品链接')}}金/单)</el-checkbox>
          </el-col>
          <el-col :span="18">
            <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span>要求买手核对商品链接，有些操作难度,可能影响做单   </span>
                </span>
            </div>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('账号等级限制')">
        <el-divider></el-divider>
        <el-row :gutter="5" align="center" style="margin: 10px 0px;">
          <el-col :span="24">
            <el-row>
              <el-col :span="6" style="line-height: 28px;">
                <el-checkbox v-model="childdata.accountLimitChecked">账号等级限制(+{{getAttrPrice('账号等级限制')}}金/单)</el-checkbox>
              </el-col>
              <el-col :span="18">
                <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span>仅限帐号的等级达到该级别才可做单  </span>
                </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="2" v-if="childdata.accountLimitChecked"
                    style="border: 1px solid red;margin: 5px 0px;">
              <el-col :span="24" class="bItem">
                <el-form-item label-width="0">
                  <el-radio-group v-model="childdata.accountLimitLever">
                    <el-radio :label="0">低于3心无法接单</el-radio>
                    <el-radio :label="1">低于4心无法接单</el-radio>
                    <el-radio :label="2">低于5心无法接单</el-radio>
                    <el-radio :label="3">低于1钻无法接单</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('淘气值限制')">
        <el-divider></el-divider>
        <el-row :gutter="5" align="center" style="margin: 10px 0px;">
          <el-col :span="24">
            <el-row>
              <el-col :span="6" style="line-height: 28px;">
                <el-checkbox v-model="childdata.taoLimitChecked">淘气值限制(+{{getAttrPrice('淘气值限制')}}金/单)</el-checkbox>
              </el-col>
              <el-col :span="18">
                <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span>仅限帐号淘气值必须达到该值以上才可接单  </span>
                </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="2" v-if="childdata.taoLimitChecked"
                    style="border: 1px solid red;margin: 5px 0px;">
              <el-col :span="24" class="bItem">
                <el-form-item label-width="0">
                  <el-radio-group v-model="childdata.taoLimitLever">
                    <el-radio :label="0">低于400无法接单</el-radio>
                    <el-radio :label="1">低于650无法接单</el-radio>
                    <el-radio :label="2">低于800无法接单</el-radio>
                    <el-radio :label="3">低于1000无法接单</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('浏览副宝贝')">
        <el-divider></el-divider>
        <el-row :gutter="5" align="center" style="margin: 10px 0px;">
          <el-col :span="24">
            <el-row>
              <el-col :span="6" style="line-height: 28px;">
                <el-checkbox v-model="childdata.browserGoodChecked">浏览副宝贝(+{{getAttrPrice('浏览副宝贝')}}金/单)</el-checkbox>
              </el-col>
              <el-col :span="18">
                <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span v-if="isTaoNoImgShow">淘宝无截图，要求买手操作不截图</span>
                  <span v-else>要求店内任意浏览其他宝贝，买手操作不截图，需要截图请勾选【需要截图】</span>
                </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="2" v-if="childdata.browserGoodChecked && !isTaoNoImgShow"
                    style="border: 1px solid red;margin: 5px 0px;">
              <el-col :span="24" class="bItem">
                <el-form-item label-width="0">
                  <el-radio-group v-model="childdata.browserGoodReview" @change="tackReviewChange">
                    <el-radio :label="0">无需截图</el-radio>
                    <el-radio :label="1">需要截图</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('加入购物车')">
        <el-divider></el-divider>
        <el-row :gutter="5" align="center" style="margin: 10px 0px;">
          <el-col :span="24">
            <el-row>
              <el-col :span="6" style="line-height: 28px;">
                <el-checkbox v-model="childdata.addCardChecked">加入购物车(+{{getAttrPrice('加入购物车')}}金/单)</el-checkbox>
              </el-col>
              <el-col :span="18">
                <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span v-if="isTaoNoImgShow">淘宝无截图，要求买手操作不截图</span>
                  <span v-else>要求买手操作不截图，需要截图请勾选【需要截图】  </span>
                </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="2" v-if="childdata.addCardChecked && !isTaoNoImgShow"
                    style="border: 1px solid red;margin: 5px 0px;">
              <el-col :span="24" class="bItem">
                <el-form-item label-width="0">
                  <el-radio-group v-model="childdata.addCardReview" @change="tackReviewChange">
                    <el-radio :label="0">无需截图</el-radio>
                    <el-radio :label="1">需要截图</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('7天内完成浏览单')">
        <el-divider></el-divider>
        <el-row>
          <el-col :span="6" style="line-height: 28px;">
            <el-checkbox v-model="childdata.limitDateChecked">七天内完成过浏览单(+{{getAttrPrice('7天内完成浏览单')}}金/单)</el-checkbox>
          </el-col>
          <el-col :span="18">
            <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span></span>
                </span>
            </div>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('直播互动留言')">
        <el-divider></el-divider>
        <el-row>
          <el-col :span="6" style="line-height: 28px;">
            <el-checkbox v-model="childdata.videoMutualChecked">直播互动留言(+{{getAttrPrice('直播互动留言')}}金/单)</el-checkbox>
          </el-col>
          <el-col :span="18">
            <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span></span>
                </span>
            </div>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('设定买家的浏览时间')">
        <el-divider></el-divider>
        <el-row :gutter="5" align="center" style="margin: 10px 0px;">
          <el-col :span="24">
            <el-row>
              <el-col :span="6" style="line-height: 28px;">
                <el-checkbox v-model="childdata.customerBrowserTimeChecked">设定买家的浏览时间(+{{getAttrPrice('设定买家的浏览时间')}}金/单)</el-checkbox>
              </el-col>
              <el-col :span="18">
                <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span>控制买手核验店铺成功后多久才可以操作下单并提交订单号 </span>
                </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="2" v-if="childdata.customerBrowserTimeChecked"
                    style="border: 1px solid red;margin: 5px 0px;">
              <el-col :span="24" class="bItem">
                <el-form-item label-width="0">
                  <el-radio-group v-model="childdata.cbrowserTimeLever">
                    <el-radio :label="0">1分钟</el-radio>
                    <el-radio :label="1">2分钟</el-radio>
                    <el-radio :label="2">3分钟</el-radio>
                    <el-radio :label="3">4分钟</el-radio>
                    <el-radio :label="4">5分钟</el-radio>
                    <el-radio :label="5">6分钟</el-radio>
                    <el-radio :label="6">7分钟</el-radio>
                    <el-radio :label="7">8分钟</el-radio>
                    <el-radio :label="8">9分钟</el-radio>
                    <el-radio :label="9">10分钟</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('淘宝真实人工流量')">
        <el-divider></el-divider>
        <el-row :gutter="5" align="center" style="margin: 10px 0px;">
          <el-col :span="24">
            <el-row>
              <el-col :span="6" style="line-height: 28px;">
                <el-checkbox v-model="childdata.realyPersonFlowChecked">淘宝真实人工流量(+{{getAttrPrice('淘宝真实人工流量')}}金/单)</el-checkbox>
              </el-col>
              <el-col :span="18">
                <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span>按关键字搜索进入商品链接，淘气值≥2400，深入浏览2个商品，浏览时间121-180秒，任务创建后不能退款</span>
                </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="2" v-if="childdata.realyPersonFlowChecked"
                    style="border: 1px solid red;margin: 5px 0px;">
              <el-col :span="24" class="bItem">
                <el-form-item label-width="0">
                  <el-radio-group v-model="childdata.realyPersonFlowLever">
                    <el-radio :label="0">1流量</el-radio>
                    <el-radio :label="1">2流量</el-radio>
                    <el-radio :label="2">3流量</el-radio>
                    <el-radio :label="3">4流量</el-radio>
                    <el-radio :label="4">5流量</el-radio>
                    <el-radio :label="5">10流量</el-radio>
                    <el-radio :label="6">15流量</el-radio>
                    <el-radio :label="7">20流量</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('允许使用优惠券及红包')">
        <el-divider></el-divider>
        <el-row>
          <el-col :span="6" style="line-height: 28px;">
            <el-checkbox v-model="childdata.isCanUsePackgeChecked">允许使用优惠券及红包(+{{getAttrPrice('允许使用优惠券及红包')}}金/单)</el-checkbox>
          </el-col>
          <el-col :span="18">
            <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span></span>
                </span>
            </div>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('允许使用信用卡')">
        <el-divider></el-divider>
        <el-row>
          <el-col :span="6" style="line-height: 28px;">
            <el-checkbox v-model="childdata.isCanUseCartChecked">允许使用信用卡(+{{getAttrPrice('允许使用优惠券及红包')}}金/单)</el-checkbox>
          </el-col>
          <el-col :span="18">
            <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span></span>
                </span>
            </div>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('允许使用花呗')">
        <el-divider></el-divider>
        <el-row>
          <el-col :span="6" style="line-height: 28px;">
            <el-checkbox v-model="childdata.isCanUseAlipayChecked">允许使用花呗(+{{getAttrPrice('允许使用花呗')}}金/单)</el-checkbox>
          </el-col>
          <el-col :span="18">
            <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span></span>
                </span>
            </div>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('浏览目标宝贝')">
        <el-divider></el-divider>
        <el-row :gutter="5" align="center" style="margin: 10px 0px;">
          <el-col :span="24">
            <el-row>
              <el-col :span="6" style="line-height: 28px;">
                <el-checkbox v-model="childdata.browserTargetGoodChecked">浏览目标宝贝(+{{getAttrPrice('浏览目标宝贝')}}金/单)</el-checkbox>
              </el-col>
              <el-col :span="18">
                <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span v-if="isTaoNoImgShow">淘宝无截图，要求买手操作不截图</span>
                  <span v-else>要求买手操作不截图，需要截图请勾选【需要截图】</span>
                </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="2" v-if="childdata.browserTargetGoodChecked && !isTaoNoImgShow"
                    style="border: 1px solid red;margin: 5px 0px;">
              <el-col :span="24" class="bItem">
                <el-form-item label-width="0">
                  <el-radio-group v-model="childdata.browserTargetGoodReview">
                    <el-radio :label="0">无需截图</el-radio>
                    <el-radio :label="1">需要截图</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('需要假聊')">
        <el-divider></el-divider>
        <el-row :gutter="5" align="center" style="margin: 10px 0px;">
          <el-col :span="24">
            <el-row>
              <el-col :span="6" style="line-height: 28px;">
                <el-checkbox v-model="childdata.needToTalkChecked">需要假聊(+{{getAttrPrice('需要假聊')}}金/单)</el-checkbox>
              </el-col>
              <el-col :span="18">
                <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span v-if="isTaoNoImgShow">淘宝无截图，要求买手操作不截图</span>
                  <span v-else>要求买手操作不截图，需要截图请勾选【需要截图】</span>
                </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="2" v-if="childdata.needToTalkChecked && !isTaoNoImgShow"
                    style="border: 1px solid red;margin: 5px 0px;">
              <el-col :span="24" class="bItem">
                <el-form-item label-width="0">
                  <el-radio-group v-model="childdata.needToTalkReview" @change="tackReviewChange">
                    <el-radio :label="0">无需截图</el-radio>
                    <el-radio :label="1">需要截图</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('收藏店铺')">
        <el-divider></el-divider>
        <el-row :gutter="5" align="center" style="margin: 10px 0px;">
          <el-col :span="24">
            <el-row>
              <el-col :span="6" style="line-height: 28px;">
                <el-checkbox v-model="childdata.collectShopChecked">收藏店铺(+{{getAttrPrice('收藏店铺')}}金/单)</el-checkbox>
              </el-col>
              <el-col :span="18">
                <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span v-if="isTaoNoImgShow">淘宝无截图，要求买手操作不截图</span>
                  <span v-else>要求买手操作不截图，需要截图请勾选【需要截图】</span>
                </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="2" v-if="childdata.collectShopChecked && !isTaoNoImgShow"
                    style="border: 1px solid red;margin: 5px 0px;">
              <el-col :span="24" class="bItem">
                <el-form-item label-width="0">
                  <el-radio-group v-model="childdata.collectShopReview">
                    <el-radio :label="0">无需截图</el-radio>
                    <el-radio :label="1">需要截图</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('收藏宝贝')">
        <el-divider></el-divider>
        <el-row :gutter="5" align="center" style="margin: 10px 0px;">
          <el-col :span="24">
            <el-row>
              <el-col :span="6" style="line-height: 28px;">
                <el-checkbox v-model="childdata.collectGoodChecked">收藏宝贝(+{{getAttrPrice('收藏宝贝')}}金/单)</el-checkbox>
              </el-col>
              <el-col :span="18">
                <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span v-if="isTaoNoImgShow">淘宝无截图，要求买手操作不截图</span>
                  <span v-else>要求买手操作不截图，需要截图请勾选【需要截图】</span>
                </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="2" v-if="childdata.collectGoodChecked && !isTaoNoImgShow"
                    style="border: 1px solid red;margin: 5px 0px;">
              <el-col :span="24" class="bItem">
                <el-form-item label-width="0">
                  <el-radio-group v-model="childdata.collectGoodReview" @change="tackReviewChange">
                    <el-radio :label="0">无需截图</el-radio>
                    <el-radio :label="1">需要截图</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('地域限制')">
        <el-divider></el-divider>
        <el-row :gutter="5" align="center" style="margin: 10px 0px;">
          <el-col :span="24">
            <el-row>
              <el-col :span="6" style="line-height: 28px;">
                <el-checkbox v-model="childdata.localLimitChecked">地域限制(+{{getAttrPrice('地域限制')}}金/单)</el-checkbox>
              </el-col>
              <el-col :span="18">
                <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span>仅限选择地址用户【可接】或者【不可接】单</span>
                </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="2" v-if="childdata.localLimitChecked"
                    style="border: 1px solid red;margin: 5px 0px;">
              <div style="margin: 5px;">
                <el-row style="background-color: mistyrose">
                  <el-col :span="24" class="bItem">
                    <el-form-item label-width="0">
                      <el-radio-group v-model="childdata.localLimitReview">
                        <el-radio :label="0">可接单</el-radio>
                        <el-radio :label="1">不可接单</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col span="24">
                    <el-checkbox-group v-model="childdata.localInfosChecked">
                      <el-checkbox v-for="prov in childdata.provinces" :label="prov.provinceName"
                                   :key="prov.provinceNum">
                        {{ prov.provinceName }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </el-col>
                </el-row>
              </div>
            </el-row>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('年龄限制')">
        <el-divider></el-divider>
        <el-row :gutter="5" align="center" style="margin: 10px 0px;">
          <el-col :span="24">
            <el-row>
              <el-col :span="6" style="line-height: 28px;">
                <el-checkbox v-model="childdata.ageLimitChecked">年龄限制(+{{getAttrPrice('年龄限制')}}金/单)</el-checkbox>
              </el-col>
              <el-col :span="18">
                <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span>仅限选择年龄段用户可接该任务</span>
                </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="2" v-if="childdata.ageLimitChecked"
                    style="border: 1px solid red;margin: 5px 0px;">
              <el-col :span="24" class="bItem">
                <el-form-item label-width="0">
                  <el-radio-group v-model="childdata.ageLimitReview" @change="tackReviewChange">
                    <el-radio :label="0">18-25</el-radio>
                    <el-radio :label="1">26-35</el-radio>
                    <el-radio :label="2">35以上</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('性别限制')">
        <el-divider></el-divider>
        <el-row :gutter="5" align="center" style="margin: 10px 0px;">
          <el-col :span="24">
            <el-row>
              <el-col :span="6" style="line-height: 28px;">
                <el-checkbox v-model="childdata.sexLimitChecked">性别限制(+{{getAttrPrice('性别限制')}}金/单)</el-checkbox>
              </el-col>
              <el-col :span="18">
                <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span>仅限选择性别用户可接该任务</span>
                </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="2" v-if="childdata.sexLimitChecked"
                    style="border: 1px solid red;margin: 5px 0px;">
              <el-col :span="24" class="bItem">
                <el-form-item label-width="0">
                  <el-radio-group v-model="childdata.sexLimitReview" @change="tackReviewChange">
                    <el-radio :label="1">男</el-radio>
                    <el-radio :label="0">女</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        </div>
        <div v-show="isShowRow('货比足迹')">
        <el-divider></el-divider>
        <el-row :gutter="5" align="center" style="margin: 10px 0px;">
          <el-col :span="24">
            <el-row>
              <el-col :span="6" style="line-height: 28px;">
                <el-checkbox v-model="childdata.compareGoodChecked">货比足迹(+{{getAttrPrice('货比足迹')}}金/单)</el-checkbox>
              </el-col>
              <el-col :span="18">
                <div style="width: 100%;text-align: left;font-size: 0.8rem;line-height: 28px">
                <span style="color: red; margin-left: 2%">
                  <i class="el-icon-question"></i>
                  <span v-if="isTaoNoImgShow">淘宝无截图，要求买手操作不截图</span>
                  <span v-else>要求买手操作不截图，需要截图请勾选【需要截图】</span>
                </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="2" v-if="childdata.compareGoodChecked && !isTaoNoImgShow"
                    style="border: 1px solid red;margin: 5px 0px;">
              <el-col :span="24" class="bItem">
                <el-form-item label-width="0">
                  <el-radio-group v-model="childdata.compareGoodReview" @change="tackReviewChange">
                    <el-radio :label="0">无需截图</el-radio>
                    <el-radio :label="1">需要截图</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {province} from "../../lib/province";
import {getServiceMoney} from "../../api/b2cbusiness/b2c_servicemoney";
import {isObjectEmpty, isStrEmpty} from "../../lib/utils";
import {getAllTaskType} from "../../api/b2cbusiness/b2c_tasktype";

export default {
  name: "ServiceAttarchComponent",
  props: ['taskTypeId'],
  data() {
    return {
      childdata: {
        commissionPrice: 0,
        wangTagChecked: false,
        wangTagSelected: 0,
        breviewChecked: false,
        autoVerifyNumChecked: false,
        customeVerifyReview: 0,
        verifyGoodLinkChecked: false,
        accountLimitChecked: false,
        accountLimitLever: 0,
        taoLimitChecked: false,
        taoLimitLever: 0,
        browserGoodChecked: false,
        browserGoodReview: 0,
        addCardChecked: false,
        addCardReview: 0,
        limitDateChecked: false,
        videoMutualChecked: false,
        customerBrowserTimeChecked: false,
        cbrowserTimeLever: 0,
        realyPersonFlowChecked: false,
        realyPersonFlowLever: 0,
        isCanUsePackgeChecked: false,
        isCanUseCartChecked: false,
        isCanUseAlipayChecked: false,
        browserTargetGoodChecked: false,
        browserTargetGoodReview: 0,
        needToTalkChecked: false,
        needToTalkReview: 0,
        collectShopChecked: false,
        collectShopReview: 0,
        collectGoodChecked: false,
        collectGoodReview: 0,
        localLimitChecked: false,
        localLimitReview: 0,
        localInfosChecked: [],
        provinces: [...province],
        ageLimitChecked: false,
        ageLimitReview: 0,
        sexLimitChecked: false,
        sexLimitReview: 0,
        compareGoodChecked: false,
        compareGoodReview: 0,
        verifyCodeChecked: false
      },
      options:[],
      taskType: 1,
      serviceData: []
    }
  },
  computed:{
    isShowRow(){
      return function (attStr) {
        let objItem = this.serviceData.find(item=>item.attach == attStr);
        return !isObjectEmpty(objItem) && objItem.isNeedUser?true:false;
      }
    },
    getAttrPrice(){
      return function (attStr) {
        let objItem = this.serviceData.find(item=>item.attach == attStr);
        if (!isObjectEmpty(objItem)){
          return isObjectEmpty(objItem.servicePrice)?0.00:objItem.servicePrice;
        }else{
          return 0.00;
        }
      }
    },
    isTaoNoImgShow(){
      return parseInt(this.taskTypeId) === 2;
    }
  },
  mounted() {
    this.getData();
  },
  activated() {
    this.getData();
  },
  methods: {
    refrashData(taskType){
      console.log("-----", taskType)
      this.taskType = taskType;
      this.getData();
      this.$forceUpdate();
    },
    getData() {
      getServiceMoney({
        btsId: 0,
        b2cTaskTypeId: this.taskType,
        servicePrice: null,
        chargesPrice: null
      }).then(res => {
        if (res.success) {
          this.serviceData = res.data;
          let objItem = this.serviceData.find(item=>item.attach == "多链接" && item.b2cTaskTypeId == this.taskType);
          if (!isObjectEmpty(objItem)){
            this.$emit("queryMoreLinkPrice", objItem.servicePrice);
          }
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.el-divider {
  margin: 8px 0;
  background: 0 0;
  border-top: 1px dashed #e33e06;
}

.bItem {
  margin-top: 8px;
  margin-left: 1%;

  .el-form-item {
    margin-bottom: 10px;
  }

  .el-form-item /deep/ .el-form-item__label {
    margin: 2px;
  }

  .el-form-item /deep/ .el-form-item__content {
    margin: 2px;
  }
}
</style>
